import { Printer, X } from "lucide-react";
import "./CreditReport2.css";
import Header from "../../../Components/TransunionHybrid2/Header";
import ConsumerCIR from "../../../Components/TransunionHybrid2/ConsumerCIR";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import AccountAndEnquirySummary from "../../../Components/TransunionHybrid2/Summary";
import PersonalDetails from "../../../Components/TransunionHybrid2/PersonalInfoSection";
import ConsumerAccountDetails from "../../../Components/TransunionHybrid2/AccountDetails";
import ConsumerEnquiryDetails from "../../../Components/TransunionHybrid2/EnquirySection";

const TransunionHybridModal2 = ({ report, onClose }) => {
  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "TransUnion Credit Report",
  });
  return (
    <div className="parent bg-black/30 backdrop-blur-md no-scrollbar">
      <div className="flex items-center gap-3 my-2">
        {/* Secondary / Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 hover:text-slate-900 active:scale-95 transition-all shadow-sm focus:outline-none focus:ring-2 focus:ring-slate-400/20"
        >
          <X className="w-4 h-4 text-slate-500" />
          Close
        </button>

        {/* Primary / Print Button */}
        <button
          onClick={handlePrint}
          type="button"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-black bg-yellow-500 rounded-xl hover:bg-[#00a1de] hover:text-white active:scale-95 transition-all shadow-sm shadow-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-500/30"
        >
          <Printer className="w-4 h-4" />
          Print
        </button>
      </div>
      <div ref={reportRef} className="report-wrapper  no-scrollbar">
        <div className="report-page">
          <Header reportData={report} />
          <ConsumerCIR reportData={report} />

          <PersonalDetails report={report} />
          <AccountAndEnquirySummary
            accountData={report?.accounts}
            enquiryData={report}
            summary={report?.reportSummary}
          />

          <ConsumerAccountDetails accounts={report?.accounts} />

          <ConsumerEnquiryDetails enquiries={report?.enquiries} name={report?.personal?.name}/>

        </div>
      </div>
    </div>
  );
};

export default TransunionHybridModal2;
